import { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { FaWhatsapp, FaCalendarCheck } from 'react-icons/fa';
import ctaBg from '../assets/images/cta-bg.jpg';
import './CTABanner.css';

export default function CTABanner() {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: '-60px' });

  const openWhatsApp = () => {
    window.open('https://wa.me/918605246832?text=Hi%2C%20I%20want%20to%20start%20my%20business%20with%20RRP%20%26%20Associates', '_blank');
  };

  const scrollToContact = () => {
    document.querySelector('#contact')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section className="cta-banner" ref={ref} style={{ backgroundImage: `url(${ctaBg})` }}>
      {/* Background pattern */}
      <div className="cta-banner__pattern" />

      <motion.div
        className="container cta-banner__inner"
        initial={{ opacity: 0, y: 40 }}
        animate={inView ? { opacity: 1, y: 0 } : {}}
        transition={{ duration: 0.6, ease: 'easeOut' }}
      >
        <motion.div
          className="cta-banner__tag"
          initial={{ opacity: 0, scale: 0.9 }}
          animate={inView ? { opacity: 1, scale: 1 } : {}}
          transition={{ delay: 0.2, duration: 0.4 }}
        >
          ⚡ Starting @ ₹3,999 | Limited Offer
        </motion.div>

        <motion.h2
          className="cta-banner__headline"
          initial={{ opacity: 0, y: 20 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ delay: 0.3, duration: 0.5 }}
        >
          Ready to Start Your Business?
        </motion.h2>

        <motion.p
          className="cta-banner__sub"
          initial={{ opacity: 0 }}
          animate={inView ? { opacity: 1 } : {}}
          transition={{ delay: 0.45, duration: 0.5 }}
        >
          Talk to our experts today and get your business registered in days, not weeks.
        </motion.p>

        <motion.div
          className="cta-banner__btns"
          initial={{ opacity: 0, y: 20 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ delay: 0.55, duration: 0.5 }}
        >
          <motion.button
            className="btn-primary"
            onClick={scrollToContact}
            whileHover={{ scale: 1.04, boxShadow: '0 8px 28px rgba(201,168,76,0.5)' }}
            whileTap={{ scale: 0.97 }}
          >
            <FaCalendarCheck /> Book Free Consultation
          </motion.button>
          <motion.button
            className="btn-outline"
            onClick={openWhatsApp}
            whileHover={{ scale: 1.04 }}
            whileTap={{ scale: 0.97 }}
          >
            <FaWhatsapp size={18} /> WhatsApp Now
          </motion.button>
        </motion.div>
      </motion.div>
    </section>
  );
}
